import {
  Component,
  Input,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  inject,
} from '@angular/core';
import Chart from 'chart.js/auto';
import { Subject, takeUntil } from 'rxjs';
import { InfoCardComponent } from '../InfoCardComponent/dashboard.component';
import { NotificationService } from '../utils/notification.service';
import { DashboardService } from '../../services/cng-sails/dashboard/dashboard.service';
import { FormBuilder } from '@angular/forms';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-chart-dashboard',
  templateUrl: './chart-dashboard.component.html',
  styleUrls: ['./chart-dashboard.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class ChartDashboardComponent implements AfterViewInit, OnDestroy {
  getOwnershipCount(type: string): number {
    const data = localStorage.getItem('ownership_type_count');
    if (!data) return 0;
    try {
      const arr = JSON.parse(data);
      const found = arr.find((item: any) => item.ownership_type === type);
      return found ? found.ownership_type_count : 0;
    } catch {
      return 0;
    }
  }
  private destroyed$ = new Subject<void>();
  public soldQtyDayWiseChartWidth = 90; // default
  public soldQtyplantWiseChartWidth = 90; // default
  public dummyData = Array.from({ length: 40 });
  public minWidth =64;
  public maxWidth = 100;
  showmovementChart = true;
  showStationPlantWise = false;
  showSoldQtyByDayStationType = false;

  @Input() stationData: { label: string; value: number }[] = [];
  @Input() ownershipData: { label: string; value: number }[] = [];
  @Input() movementData: { label: string; value: number }[] = [];
  @Input() dashboardApplyFilter: any = {};
  @ViewChild('stationChart') stationChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('ownershipChart') ownershipChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('movementChart') movementChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('stationTypeSoldQty') movementChartRef2!: ElementRef<HTMLCanvasElement>;
  @ViewChild('soldQtyByDayStationType') movementChartRef3!: ElementRef<HTMLCanvasElement>;

  notificationService = inject(NotificationService);
  dashboardService = inject(DashboardService);
  fb = inject(FormBuilder);
  activeStationType: any = null;

  private charts: { [key: string]: Chart | null } = {};
  ngAfterViewInit(): void {
    this.createChart('stationChart', this.stationChartRef.nativeElement, 'Station Type wise', this.stationData);
    this.createChart('ownershipChart', this.ownershipChartRef.nativeElement, 'Ownership Type wise', this.ownershipData);
    this.createChart('movementChart', this.movementChartRef.nativeElement, 'Movement Type wise', this.movementData);
  }

  private destroyChart(chartKey: string) {
    if (this.charts[chartKey]) {
      this.charts[chartKey]!.destroy();
      this.charts[chartKey] = null;
    }
  }

  private createChart(
    chartKey: string,
    canvas: HTMLCanvasElement,
    title: string,
    data: { label: string; value: number }[]
  ) {
    this.destroyChart(chartKey);
  
    const paletteMap: { [key: string]: string[] } = {
      'Station Type wise': ['#00BFA6', '#26C6DA', '#00ACC1', '#00838F', '#004D40'],
      'Ownership Type wise': ['#FFD700', '#FFC107', '#FFB300', '#FFA000', '#FF8F00'],
      'Movement Type wise': ['#D81B60', '#C2185B', '#AD1457', '#880E4F', '#6A1B9A'],
    };
  
    const defaultPalette = ['#5C6BC0', '#3949AB', '#1E88E5', '#1976D2', '#0D47A1'];
    const selectedPalette = paletteMap[title] || defaultPalette;
    const backgroundColors = data.map((_, i) => selectedPalette[i % selectedPalette.length]);
  
    // High-DPI Scaling for HD charts
    const dpi = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpi;
    canvas.height = rect.height * dpi;
    const ctx = canvas.getContext('2d')!;
    ctx.scale(dpi, dpi);
  
    // Use line chart function for specific charts, otherwise use bar 
    console.log("chartKeyqweqwe",chartKey);
    if (chartKey === 'soldQtyByDayStationType') {
      this.createLineChart(chartKey, canvas, title, data);
      return;
    }
  
    this.charts[chartKey] = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: data.map((d) => d.label),
        datasets: [
          {
            label: 'Qty Sold',
            data: data.map((d) => d.value),
            backgroundColor: backgroundColors,
            borderColor: backgroundColors,
            borderWidth: 2,
          },
        ],
      },
      options: {
        plugins: {
          legend: { 
            display: false,
            labels: {
              font: {
                  size: 18,
                  weight: 'bold'
              }
            }
          },
          tooltip: {
            enabled: true,
            mode: 'index',
            intersect: false,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            titleColor: '#333',
            bodyColor: '#333',
            borderColor: '#ddd',
            borderWidth: 1,
          },
        },
        scales: {
          y: {
              grid: {
              },
             beginAtZero: true,
             ticks: {
              font: {
                  size: 10,
              },
              color: 'black'
          }
             },
             x:{
              grid: {
              },
              ticks: {
                font: {
                    size: 10,
                },
                color: 'black'
            }
             }
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const elementIndex = elements[0].index;
            const clickedLabel = data[elementIndex].label;
            const clickedValue = data[elementIndex].value;
            switch (title) {
              case 'Ownership Type wise':
                console.log('Ownership Type wise clicked:', clickedLabel, clickedValue);
                break;
              case 'Station Type wise':
                console.log('Station Type wise clicked:', clickedLabel, clickedValue);
                this.activeStationType = clickedLabel;
                this.getStationTypePlant(clickedLabel);
                break;
              case 'Station Plant wise':
                console.log('Station Plant wise clicked:', clickedLabel, clickedValue);
                this.getPlantDateWise(clickedLabel);
                break;
            }
          }
        },
      },
    });
  }

  private createLineChart(
    chartKey: string,
    canvas: HTMLCanvasElement,
    title: string,
    data: { label: string; value: number }[]
  ) {    
    const lineColor = '#1976D2'; // Primary color for line chart
    this.destroyChart(chartKey);

    // High-DPI Scaling for HD charts
    const dpi = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpi;
    canvas.height = rect.height * dpi;
    const ctx = canvas.getContext('2d')!;
    ctx.scale(dpi, dpi);
    this.charts[chartKey] = new Chart(ctx, {
      type: 'line',
      data: {
        labels: data.map((d) => d.label),
        datasets: [
          {
            label: 'Qty Sold',
            data: data.map((d) => d.value),
            // Light background
            borderColor: lineColor,
            borderWidth: 2,
            pointBackgroundColor: lineColor,
            pointRadius: 4,
            pointHoverRadius: 6,
            fill: true,
            tension: 0.3,
            borderCapStyle: 'round',
            borderJoinStyle: 'round',
            pointStyle: 'circle',
            pointBorderColor: lineColor,
            pointBorderWidth: 2,
            pointHoverBackgroundColor: lineColor,
            pointHoverBorderColor: lineColor,
            pointHoverBorderWidth: 2,
            pointHitRadius: 10,
            pointRotation: 0,            
          },
        ],
      },
      options: {
        plugins: {
          legend: {
             display: false,
             labels: {
              font: {
                  size: 14,
                  weight: 'bold'
              }
          }
             },
          tooltip: {
            enabled: true,
            mode: 'index',
            intersect: false,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            titleColor: '#333',
            bodyColor: '#333',
            borderColor: '#ddd',
            borderWidth: 1,
          },
        },
        scales: {
          y: { 
            beginAtZero: true,
            grid: {
            },
            ticks: {
              font: {
                  size: 10,
              },
          }
          },
          x: {
            grid: {
              display: false,
            },
            ticks: {
              font: {
                  size: 10,
              },
          }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          onComplete: (animation) => {
            try {
              const chart = animation.chart;
              const sourceCanvas = chart.ctx.canvas;
              const chartArea = chart.chartArea;
              const copyWidth = chartArea.left;
              const copyHeight = chartArea.bottom + 5;
              const targetCanvas = document.getElementById("myChartAxis") as HTMLCanvasElement;
              if (targetCanvas) {
                const targetCtx = targetCanvas.getContext("2d");
                if (targetCtx) {
                  targetCanvas.width = copyWidth;
                  targetCanvas.height = copyHeight;
                  targetCtx.clearRect(0, 0, copyWidth, copyHeight);
                  targetCtx.drawImage(
                    sourceCanvas,
                    0, 0, copyWidth, copyHeight,
                    0, 0, copyWidth, copyHeight
                  );
                }
              }
            } catch (e) {
            }
          }
        }
      },
    });
  }

  private getStationTypePlant(params: any) {
    this.showmovementChart = false;
    this.showStationPlantWise = true;
    this.showSoldQtyByDayStationType = false;
    this.dashboardService.dashboardfilterSoldQtyByStationType({
      ...this.dashboardApplyFilter,
      station_type: params
    })
    .pipe(takeUntil(this.destroyed$))
    .subscribe(item => {
      let response: any = item;
      if (response.code == 200 && Array.isArray(response.data)) {
        const chartData = response.data.map((d: any) => ({
          label: d.plant_code,
          value: d.total_quantity_sold
        }));
        this.soldQtyplantWiseChartWidth = Math.max(this.minWidth, Math.min(this.maxWidth, chartData?.length)*10);
        setTimeout(() => {
          this.createChart('stationTypeSoldQty', this.movementChartRef2.nativeElement, 'Station Plant wise', chartData);
        }, 100);
      }
    });
  }

  private getPlantDateWise(params: any) {
    this.showmovementChart = false;
    this.showStationPlantWise = false;
    this.showSoldQtyByDayStationType = true;
    console.log("asdas",  
      {
        ...this.dashboardApplyFilter,
        station_type: this.activeStationType,
        plant_code: params
      })
    this.dashboardService.soldQtyByDayWiseStationType({
      ...this.dashboardApplyFilter,
      plant_code: [params]
    })
    .pipe(takeUntil(this.destroyed$))
    .subscribe(item => {
      let response: any = item;
      if (response.code == 200 && Array.isArray(response.data)) {
        const chartData = response.data.map((d: any) => ({
          label: d.entry_date,
          value: d.total_quantity_sold
        }));
        this.soldQtyDayWiseChartWidth = Math.max(this.minWidth, Math.min(this.maxWidth, chartData?.length)*10);
        setTimeout(() => {
          this.createLineChart('soldQtyByDayStationType', this.movementChartRef3.nativeElement, 'Qty', chartData);
        }, 100);
      }
    });
  }

  ngOnDestroy(): void {
    Object.keys(this.charts).forEach((chartKey) => this.destroyChart(chartKey));
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  resetPlantWise(){
    this.showmovementChart = false;
    this.showStationPlantWise = true;
    this.showSoldQtyByDayStationType = false;
    this.getStationTypePlant(this.activeStationType);
  }
  resetMovement() {
    this.showmovementChart = true;
    this.showStationPlantWise = false;
    this.showSoldQtyByDayStationType = false;
    setTimeout(() => {
      this.createChart('movementChart', this.movementChartRef.nativeElement, 'Movement Type wise', this.movementData);
    }, 100);
  }
}
